import { createGlobalStyle } from "styled-components";

const primaryOne = !window?.origin.includes("app") ? "#535353" : "#B31D15"

const secondaryThree = !window?.origin.includes("app") ? "#616161" : "#CD2118"

export const GlobalStyles = createGlobalStyle`
    html {
        --primary-one: ${primaryOne};
        --primary-two: #535353;
        --primary-three: #1D1D1B;
        --secondary-one: #FFFFFF;
        --secondary-two: #F1F1F1;
        --secondary-three: ${secondaryThree};
        --secondary-four: #A8A8A8;
        --tertiary-one : #35D0A5;
        --tertiary-two: #C29F43;
        --tertiary-three: #F9F5EC;
        --tertiary-four: #5E80DB;
        --tertiary-five: #E6EBF9;
        --tertiary-six: #1E8065;
        --tertiary-seven: #C1F0E3;
    }
`;
